import { tdsFetch } from '@/utils/fetch';

/**
 * 结构化落库 API 封装
 * 对应 Java 后端（8082）：/innovation/innovation/... （代理转发）
 * 全部为"静默写入"：失败由调用方 catch，不影响页面流程
 */

const sysPrefix = '/innovation/innovation';

// 成果物上传等需要拼完整前缀的调用方从这里取，避免各处硬编码
export { sysPrefix };

// 技术路径：按项目删旧插新，返回带正式ID的列表（前端据此建立 临时ID->正式ID 映射）
export const replaceTechnicalPaths = (projectId, paths) => {
  return tdsFetch(`${sysPrefix}/technical-path/replace?projectId=${projectId}`, {
    method: 'POST',
    body: paths,
    joinPrefix: false
  })
}

// 技术路径：按正式ID更新（详情补全后调用）
export const updateTechnicalPath = (id, path) => {
  return tdsFetch(`${sysPrefix}/technical-path/${id}`, {
    method: 'PUT',
    body: path,
    joinPrefix: false
  })
}

// 技术路径：按项目查询全部（刷新后重建 临时ID->正式ID 映射用）
export const listTechnicalPathsByProject = (projectId) => {
  return tdsFetch(`${sysPrefix}/technical-path/list?projectId=${projectId}`, {
    method: 'GET',
    joinPrefix: false
  })
}

// 方案：按项目查询（还原章节数组 + triplet），刷新恢复用
export const getSolutionByProject = (projectId) => {
  return tdsFetch(`${sysPrefix}/solution/by-project?projectId=${projectId}`, {
    method: 'GET',
    joinPrefix: false
  })
}

// 勾选记录：按项目查询（join 路径/专利详情），刷新恢复用
export const getSelectionDetailByProject = (projectId) => {
  return tdsFetch(`${sysPrefix}/alternative-solution/detail?projectId=${projectId}`, {
    method: 'GET',
    joinPrefix: false
  })
}

// 技术路径：更新勾选状态（勾选的 status=1，其余=0）
export const updateTechnicalPathStatus = (projectId, selectedIds) => {
  return tdsFetch(`${sysPrefix}/technical-path/update-status?projectId=${projectId}`, {
    method: 'POST',
    body: selectedIds,
    joinPrefix: false
  })
}

// 备选方案选择：按项目删旧插新（type=1 技术路径，type=2 专利）
export const replaceAlternativeSolutions = (projectId, records) => {
  return tdsFetch(`${sysPrefix}/alternative-solution/replace?projectId=${projectId}`, {
    method: 'POST',
    body: records,
    joinPrefix: false
  })
}

// 解决方案：按项目删旧插新
export const replaceSolutions = (projectId, solutions) => {
  return tdsFetch(`${sysPrefix}/solution/replace?projectId=${projectId}`, {
    method: 'POST',
    body: solutions,
    joinPrefix: false
  })
}

// AI-generated solution persistence; backend assigns source=ai.
export const replaceGeneratedSolutions = (projectId, solutions) => {
  return tdsFetch(`${sysPrefix}/solution/replace-generated?projectId=${projectId}`, {
    method: 'POST',
    body: solutions,
    joinPrefix: false
  })
}

// 成果物：新增记录
export const addArtifact = (artifact) => {
  return tdsFetch(`${sysPrefix}/generated-artifact/add`, {
    method: 'POST',
    body: artifact,
    joinPrefix: false
  })
}

// 专利：批量落库相关专利（带 tech_path_id，按公开号去重）
export const batchSavePatents = (pathId, patents) => {
  return tdsFetch(`${sysPrefix}/patent/batch-save?pathId=${pathId}`, {
    method: 'POST',
    body: patents,
    joinPrefix: false
  })
}

// 专利：按公开号去重落库（最小占位信息），返回数据库ID（解读时专利未入库用）
export const saveOrGetByExternalId = (externalId) => {
  return tdsFetch(`${sysPrefix}/patent/save-or-get`, {
    method: 'POST',
    body: {
      externalId,
      title: `专利占位-${externalId}`,
      publicationNumber: externalId
    },
    joinPrefix: false
  })
}

// 专利：按路径查询相关专利
export const getPatentsByPath = (pathId) => {
  return tdsFetch(`${sysPrefix}/patent/by-path?pathId=${pathId}`, {
    method: 'GET',
    joinPrefix: false
  })
}

// 专利解读：保存（专利级共享，external_patents.ai_interpretation）
export const savePatentInterpretation = (patentId, interpretation) => {
  return tdsFetch(`${sysPrefix}/patent/interpretation?patentId=${patentId}`, {
    method: 'POST',
    body: { interpretation },
    joinPrefix: false
  })
}

// 专利解读：读取（专利级共享）
export const getPatentInterpretation = (patentId) => {
  return tdsFetch(`${sysPrefix}/patent/interpretation?patentId=${patentId}`, {
    method: 'GET',
    joinPrefix: false
  })
}
